var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div class=\"input-group\">\n<color-picker options=\"opzioni\" ng-model=\"model[options.key]\"></color-picker>\n</div>\n<style>\n.color-picker-grid-inner{\n        z-index: 99999999999 !important;\n    }\n</style>";
var id1="bsscolorpicker.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;